/**
 * External dependencies.
 */
import { register } from '@wordpress/data';

/**
 * Internal dependencies.
 */
import settingStore from "./settings";

/**
 * Register stores.
 */
register(settingStore);
